module.exports = __webpack_public_path__ + "img/icon_star_default.5c914b73.svg";